import IframePage from "./IframePage";
import Home from "./Home";

const DynamicPage = ({ menuData, activePage, activePageLayout, handlePageChange, activeMenuItem }) => {
  if (activeMenuItem?.isIframe) {
    return (
      <IframePage
        urlTitle={activeMenuItem.title}
        url={activeMenuItem.url}
        menuData={menuData}
        activePage={activePage}
        activePageLayout={activePageLayout}
        handlePageChange={handlePageChange}
      />
    );
  } else {
    return (
      <Home
        key={activePage}
        menuData={menuData}
        activePage={activePage}
        activePageLayout={activePageLayout}
        handlePageChange={handlePageChange}
      />
    );
  }
};

export default DynamicPage;